// import { useEffect, useRef } from "react";
// import lottie from "lottie-web";
// import datarock from "../assets/rock/data.json";

function Hero() {
  // const container = useRef(null);

  // useEffect(() => {
  //   const anim = lottie.loadAnimation({
  //     container: container.current,
  //     renderer: "svg",
  //     loop: true,
  //     autoplay: false, // ne démarre pas tout de suite
  //     animationData: datarock,
  //   });

  //   anim.addEventListener("loaded_images", () => {
  //     anim.play();
  //   });

  //   return () => anim.destroy(); // nettoyage
  // }, []);

  return (
    // invertNegative

    <section id="heroSectionHome" className="hero section1 d-flex flex-column ">
      <div className="why ">
        <div className="introGrid"></div>
        <div className="row d-flex flex-row justify-content-center content-intro">
          <div className="col-12  mb-md-0 containTitre">
            <div className="txtv2">
              <p>
                <span>Digital Designer</span>
                <br />
                J’aide les studios et les marques à donner vie à leurs idées et
                à leur branding grâce à des animations percutantes et un design
                interactif.
              </p>
            </div>
            {/* <div className="marquee glass">
              <div className="track">
                <p className="text">Directeur Artistique digital</p>
                <p className="text">Motion Designer</p>
                <p className="text">Créatif 3D & DA Web</p>
              </div>
            </div> */}
            <div>
              <h1 className="passion-one-black">
                Votre monde <br /> sur mesure.
              </h1>
            </div>

            <div className="imgrun"></div>
          </div>
          <div className="d-flex justify-content-end btnSeeProject">
            <a href="#lesprojets" className="btn  cta">
              Voir mes projets &rarr;
            </a>
          </div>

          {/* <div className="col-12 col-md-6 d-flex justify-content-center rockHeaderContainer">
          <div ref={container} className="rockHeader"></div>
        </div> */}
        </div>
      </div>
    </section>
  );
}

export default Hero;
